const wrappers = document.querySelectorAll('.summary .summary-wrapper');

wrappers.forEach((wrapper) => {
	const content = wrapper.querySelector('.summary-content');
	const toggle = wrapper.querySelector('.summary-toggle');
	if (!content || !toggle) return;

	// Measure the natural height first, then apply the collapsed cap.
	const fullHeight = content.scrollHeight;
	wrapper.classList.add('is-collapsible');
	const collapsedHeight = content.clientHeight;

	// Nothing hidden — drop the cap and keep the toggle hidden.
	if (fullHeight <= collapsedHeight + 1) {
		wrapper.classList.remove('is-collapsible');
		return;
	}

	toggle.hidden = false;

	toggle.addEventListener('click', () => {
		const expanded = toggle.getAttribute('aria-expanded') === 'true';

		if (expanded) {
			content.style.maxHeight = `${collapsedHeight}px`;
			toggle.setAttribute('aria-expanded', 'false');
			wrapper.classList.remove('is-expanded');
		} else {
			content.style.maxHeight = `${content.scrollHeight}px`;
			toggle.setAttribute('aria-expanded', 'true');
			wrapper.classList.add('is-expanded');
		}
	});
});